export const environment = {
  production: process.env.NODE_ENV === "production",
  basePath: "",
  publicPath: "",
  buildNo: "13",
  environment: "prod",
};
